import styled from 'styled-components';
import { breakpoints } from '@zopauk/react-components';

export interface PaddingTop {
  desktop?: string;
  mobile?: string;
}

export const Page = styled.div`
  padding-top: 64px;

  @media screen and (max-width: ${breakpoints.phone}px) {
    padding-top: 32px;
  }
`;

export const Container = styled.div<{ fullHeight: boolean; maxWidth: number }>`
  max-width: ${({ maxWidth }) => `${maxWidth}px`};
  min-height: ${({ fullHeight }) => fullHeight && '80vh'};
  margin: 0 auto;
`;

export const Subtitle = styled.div`
  margin-top: 24px;
  max-width: 650px;
`;

export const Heading = styled.div`
  max-width: 768px;
  margin: 0 auto;
  margin-bottom: 56px;

  @media screen and (max-width: ${breakpoints.phone}px) {
    margin-bottom: 32px;
  }

  @media screen and (max-width: ${breakpoints.desktop}px) {
    padding: 0 1em;
  }
`;

export const Caption = styled.div`
  max-width: 600px;
  margin-top: 1em;
`;

export const BodyWrapper = styled.div`
  @media screen and (max-width: ${breakpoints.desktop}px) {
    padding: 0 1em;
  }
`;

export const SubtitleWrapper = styled.div`
  margin-bottom: 2em;
`;
